<button
  *ngIf="button"
  type="button"
  class="btn b3-semibold btn-link gpt-16 gpt-sm-32 px-0 text-decoration-none"
  [gptDataTrack]="button.dataTrack"
  (click)="openModal(button.type)"
>
  {{ button.text | translate }}
</button>
